import { styled, FormHelperText } from '@mui/material';

export const HelperText = styled(FormHelperText)(() => ({
  marginLeft: 32,
}));
